




























































import Vue from 'vue'
import { mapGetters } from 'vuex'
import { AccountType } from '../../../../store/models/Account'
import api from '../../../../api'

interface AccountBalance {
  owner: string
  productId: string
  type: string
  otm: string
  balance: number
}

export default Vue.extend({
  data() {
    return {
      columns: [
        { label: 'SFD', field: 'name', searchable: true },
        { label: 'Décaissement MTN', field: 'mtnBalance' },
        { label: 'Remboursement MTN', field: 'mtnRefundBalance' },
        { label: 'Interêts MTN', field: 'mtnInterestBalance' },
        { label: 'Décaissement MOOV', field: 'moovBalance' },
        { label: 'Remboursement MOOV', field: 'moovRefundBalance' },
        { label: 'Interêts MOOV', field: 'moovInterestBalance' }
      ],
      items: [] as { id: string; name: string }[],
      allAccounts: [] as AccountBalance[]
    }
  },

  computed: {
    ...mapGetters('product', ['getCurrentProduct'])
  },

  methods: {
    getAccounts(organizationId: string | null): Array<AccountBalance> {
      console.log('getAccounts:', organizationId)
      console.log('acounts:', this.allAccounts)
      if (organizationId) {
        return this.allAccounts.filter(
          (acc: AccountBalance) =>
            acc.owner === organizationId &&
            acc.productId == this.getCurrentProduct.id
        )
      }
      return this.allAccounts.filter(
        (acc: AccountBalance) =>
          this.getCurrentProduct.sfdConcern.includes(acc.owner) &&
          acc.productId == this.getCurrentProduct.id
      )
    },
    soldeDecaissementMoov(organizationId: string | null = null): number {
      const accounts = this.getAccounts(organizationId)
      console.log({ accounts }, 'soldeDecaissementMoov', organizationId)
      const moovAccounts = accounts.filter((value: any) => {
        return value.type == AccountType.DISBURSEMENT && value.otm == 'moov'
      })
      if (moovAccounts.length > 0)
        return moovAccounts.reduce((acc, cur) => acc + cur.balance, 0)
      return 0
    },

    soldeDecaissementMtn(organizationId: string | null = null): number {
      const accounts = this.getAccounts(organizationId)
      console.log({ accounts }, 'soldeDecaissementMoov')
      const mtnAccounts = accounts.filter((value: any) => {
        return value.type == AccountType.DISBURSEMENT && value.otm == 'mtn'
      })
      if (mtnAccounts.length)
        return mtnAccounts.reduce((acc, cur) => acc + cur.balance, 0)
      return 0
    },

    soldeDecaissement(organizationId: string | null = null): number {
      return (
        this.soldeDecaissementMtn(organizationId) +
        this.soldeDecaissementMoov(organizationId)
      )
    },

    soldeRembourssementMoov(organizationId: string | null = null): number {
      const accounts = this.getAccounts(organizationId)
      console.log({ accounts }, 'soldeDecaissementMoov')
      const moovAccounts = accounts.filter((value: any) => {
        return value.type == AccountType.REFUND && value.otm == 'moov'
      })
      if (moovAccounts.length > 0)
        return moovAccounts.reduce((acc, cur) => acc + cur.balance, 0)
      return 0
    },

    soldeRembourssementMtn(organizationId: string | null = null): number {
      const accounts = this.getAccounts(organizationId)
      console.log({ accounts }, 'soldeDecaissementMoov')
      const mtnAccounts = accounts.filter((value: any) => {
        return value.type == AccountType.REFUND && value.otm == 'mtn'
      })

      if (mtnAccounts.length > 0)
        return mtnAccounts.reduce((acc, cur) => acc + cur.balance, 0)
      return 0
    },

    soldeRembourssement(organizationId: string | null = null): number {
      return (
        this.soldeRembourssementMoov(organizationId) +
        this.soldeRembourssementMtn(organizationId)
      )
    },
    soldeInteretMoov(organizationId: string | null = null): number {
      const accounts = this.getAccounts(organizationId)
      const moovAccounts = accounts.filter((value: any) => {
        return value.type == AccountType.INTEREST && value.otm == 'moov'
      })
      if (moovAccounts.length > 0)
        return moovAccounts.reduce((acc, cur) => acc + cur.balance, 0)
      return 0
    },

    soldeInteretMtn(organizationId: string | null = null): number {
      const accounts = this.getAccounts(organizationId)
      const mtnAccounts = accounts.filter((value: any) => {
        return value.type == AccountType.INTEREST && value.otm == 'mtn'
      })

      if (mtnAccounts.length > 0)
        return mtnAccounts.reduce((acc, cur) => acc + cur.balance, 0)
      return 0
    },

    soldeInteret(organizationId: string | null = null): number {
      return (
        this.soldeInteretMoov(organizationId) +
        this.soldeInteretMtn(organizationId)
      )
    }
  },

  async mounted() {
    console.log({ items: this.items })

    try {
      // Récupérer les soldes calculés depuis le nouvel endpoint
      const response = await api.get('/organizations/ovas/balances', {
        params: { productId: this.getCurrentProduct.id }
      })
      const { balances } = response.data

      // Filtrer les organisations concernées par le produit actuel
      this.items = balances
        .filter((balance: any) =>
          this.getCurrentProduct.sfdConcern.includes(balance.organizationId)
        )
        .map((balance: any) => ({
          id: balance.organizationId,
          name: balance.organizationName
        }))

      // Transformer les soldes en format Account pour compatibilité avec les méthodes existantes
      this.allAccounts = []

      balances.forEach((balance: any) => {
        // Compte de décaissement MTN
        this.allAccounts.push({
          owner: balance.organizationId,
          productId: this.getCurrentProduct.id,
          type: 'disbursement',
          otm: 'mtn',
          balance: balance.disbursementMtn
        })

        // Compte de décaissement MOOV
        this.allAccounts.push({
          owner: balance.organizationId,
          productId: this.getCurrentProduct.id,
          type: 'disbursement',
          otm: 'moov',
          balance: balance.disbursementMoov
        })

        // Compte de remboursement MTN
        this.allAccounts.push({
          owner: balance.organizationId,
          productId: this.getCurrentProduct.id,
          type: 'refund',
          otm: 'mtn',
          balance: balance.reimbursementMtn
        })

        // Compte de remboursement MOOV
        this.allAccounts.push({
          owner: balance.organizationId,
          productId: this.getCurrentProduct.id,
          type: 'refund',
          otm: 'moov',
          balance: balance.reimbursementMoov
        })

        // Compte d'intérêts MTN
        this.allAccounts.push({
          owner: balance.organizationId,
          productId: this.getCurrentProduct.id,
          type: 'interest',
          otm: 'mtn',
          balance: balance.interestMtn
        })

        // Compte d'intérêts MOOV
        this.allAccounts.push({
          owner: balance.organizationId,
          productId: this.getCurrentProduct.id,
          type: 'interest',
          otm: 'moov',
          balance: balance.interestMoov
        })
      })

      console.log({ items: this.items, accounts: this.allAccounts })
      console.log('sfd-concern', this.getCurrentProduct.sfdConcern)
    } catch (error) {
      console.error('Erreur lors du chargement des soldes OVA:', error)
      this.$notify.error('Erreur lors du chargement des soldes')
    }
  }
})
